import React from "react";

const Loader = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-white/60 backdrop-blur-sm"></div>

      <style>{`body { overflow: hidden; }`}</style>

      <div className="relative flex flex-col items-center justify-center">
        <div className="w-24 h-24 border-4 border-red-600 border-t-transparent rounded-full animate-spin mb-4"></div>

        <img
          src={require("../assets/images/icons/logo1.png")}
          alt="Logo"
          className="w-20 h-auto mb-4"
        />

        <p className="text-gray-700 font-semibold text-lg animate-pulse">
          Loading, please wait...
        </p>
      </div>
    </div>
  );
};

export default Loader;
